import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router-dom-v5-compat';
import { handleSuccessToast } from 'src/components/molecules';
import { useResetPasswordMutation } from 'src/graphql';
import { handleUpdatePasswordErrors } from 'src/utils/handleUpdatePasswordErrors';
import {
  ChangePasswordNewCommon,
  FormValues,
} from '../../../ChangePasswordNew/ChangePasswordNewCommon';
import { LoginContainer } from '../../ReportingLoginContainer/ReportingLoginContainer';
import {
  Description,
  FormContainer,
  Header,
} from '../../ReportingReset/ReportingReset.styles';

export const ReportingUpdatePassword = () => {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const changePassword = useResetPasswordMutation({
    onSuccess() {
      handleSuccessToast({
        toastMessage: t(
          'reporting.ReportingForgotPassword.updatePasswordSuccess',
        ),
        toastDescription: t(
          'reporting.ReportingForgotPassword.updatePasswordSuccessDescription',
        ),
      });

      setHasSubmitted(true);
    },
    onError(error: unknown) {
      handleUpdatePasswordErrors((error as Error).message);
    },
  });

  const createPassword = async (data: FormValues) => {
    const { newPassword } = data;

    if (token) {
      changePassword.mutate({
        password: newPassword,
        token,
      });
    }
  };

  return (
    <>
      {hasSubmitted ? (
        <Redirect to={'/reporting/login'} />
      ) : (
        <LoginContainer data-testid="reset">
          <Header data-testid="reporting-update-password-header">
            {t('Buttons.updatePassword')}
          </Header>
          <Description data-testid="reporting-update-password-description">
            {t('public.Password.newDescription')}
          </Description>
          <FormContainer>
            <ChangePasswordNewCommon
              createPassword={createPassword}
              updateWithToken={true}
              isLoading={false}
              buttonText={t('Buttons.updatePassword')}
              isLocalised={true}
              data-testid="update-password"
            />
          </FormContainer>
        </LoginContainer>
      )}
    </>
  );
};
